import { render, staticRenderFns } from "./TicketPrioritySelect.vue?vue&type=template&id=66b2ce31&"
import script from "./TicketPrioritySelect.vue?vue&type=script&lang=ts&"
export * from "./TicketPrioritySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports